import * as React from "react";
import { useMobileMediaQuery } from "../hooks/useMobileMediaQuery";

type Props = { children: React.ReactNode; style?: React.CSSProperties };

export const ContentWrapper = ({ children, style }: Props) => {
    const isMobile = useMobileMediaQuery();

    return (
        <div
            style={{
                maxWidth: 1200,
                width: "100%",
                padding: isMobile ? 20 : style?.padding ?? "56px 56px 0",
                margin: "0 auto",
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                ...style
            }}
        >
            {children}
        </div>
    );
};
